import { VerifyLinkRequest } from "@api/client";
import { AppStateManager } from "common/helpers/app-state-manager.utils";
import { PathEnum } from "core/routes/path.enum";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { layoutSetSteps } from "layout/_redux/actions";
import Footer from "layout/components/footer";
import Header from "layout/components/header";
import Sidebar from "layout/components/sidebar";
import Topbar from "layout/components/topbar";
import { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate, useSearchParams } from "react-router-dom";
import { invitationGetInvitation } from "./_redux/actions";
import { invitationShowHeaderSelector } from "./_redux/selectors";
import { InvitationSteps } from "./config";
import IdentificationPage from "./identification";
import ProcessoTerminatoInvitation from "./processo-terminato";
import RichiestaScadutaPage from "./richiesta-scaduta";
import WelcomePage from "./welcome";

const InvitationPage: React.FC = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const showHeader = useAppSelector(invitationShowHeaderSelector);

	const [searchParams] = useSearchParams();
	const data = searchParams.get("data") || AppStateManager.getInvitationData();

	const emailLink: VerifyLinkRequest = {
		data: data || "",
	};

	const isDesktop = window.innerWidth >= 992;

	const getInvitation = () => {
		if (data) {
			AppStateManager.setInvitationData(data);

			dispatch(invitationGetInvitation(emailLink))
				.unwrap()
				.then((res) => {
					if (res && "status" in res && (res as Response).status == 400) {
						navigate(PathEnum.richiestaScaduta);
					}
				});
		}
	};

	useEffect(() => {
		getInvitation();
		dispatch(layoutSetSteps(InvitationSteps));
	}, []);

	return (
		<>
			<Sidebar />

			<div className="wrapper d-flex flex-column min-vh-100">
				<div className="body flex-grow-1 px-0">
					{!isDesktop && showHeader && <Header />}

					{!isDesktop && <Topbar />}

					<div
						className={`container-fluid body-section m-0 ${
							showHeader ? "" : "body-section-no-header"
						} px-0`}
					>
						<Routes>
							<Route path="" element={<Navigate to={PathEnum.welcome} replace />} />

							<Route path={PathEnum.welcome} element={<WelcomePage />} />

							<Route path={`${PathEnum.identification}/*`} element={<IdentificationPage />} />

							<Route path={PathEnum.invitationComplete} element={<ProcessoTerminatoInvitation />} />

							<Route path={PathEnum.richiestaScaduta} element={<RichiestaScadutaPage />} />
						</Routes>
					</div>
				</div>

				<Footer />
			</div>
		</>
	);
};

export default InvitationPage;
